import { useNavigate } from 'react-router-dom';
import { DateTime } from 'luxon';
import IconDone from '../../components/icons/IconDone';
import IconInwork from '../../components/icons/IconInwork';

export default function ConversationProgressElment({ item }) {
   const navigate = useNavigate();
   const url = '/messages/byconvprogress/' + item.id;
   const time = DateTime.fromISO(item.dAdd.replace(/\[.*\]/, ''), { setZone: true }).toFormat('dd.MM.yyyy HH:mm');
   const isFinished = item.isFinished == 1;

   return (
      <div className='conv-prog-elem' onClick={() => navigate(url)}>
         <div className='conv-prog-info'>
            <p>{item.conversationId && item.conversationId.name ? item.conversationId.name : ''}</p>
            <p>TG: {item.outerUserId ? item.outerUserId.username : 'no telegram'}</p>
         </div>
         <div className='conv-prog-status'>
            {isFinished ? <IconDone fillColor='icon-green' /> : <IconInwork fillColor='icon-orange' />}
            <p className={isFinished ? 'conv-prog-status-done' : 'conv-prog-status-progress'}>{time}</p>
         </div>
      </div>
   );
}
